import React from "react";

// Components
import FormValidation from "pages/ticketing/components/FormValidation";

const DownloadRFIForm = ({
  handleOpenUploadForm,
  handleInputChange,
  userForm,
  show,
}) => {
  if (!show) return null;

  return (
    <div className="text-justify">
      <h3 className="mb-6 text-xl font-semibold leading-snug">
        Start your ESG Awards journey by sharing key project and governance
        information.
      </h3>
      <div className="space-y-4">
        <div>
          <label className="block text-sm font-semibold">
            Company Name<span className="text-red-500">*</span>
          </label>
          <input
            type="text"
            name="companyName"
            placeholder="Company’s Name"
            className="w-full mt-1 border rounded-md px-3 py-2 text-sm focus:ring-2 focus:ring-[#93C047] focus:outline-none"
            onChange={(e) => handleInputChange(e.target.name, e.target.value)}
            value={userForm.companyName}
          />
          <FormValidation
            value={userForm.companyName}
            showError={!userForm.validCompanyName}
          />
        </div>

        <div>
          <label className="block text-sm font-semibold">
            Contact Person Name<span className="text-red-500">*</span>
          </label>
          <input
            type="text"
            name="contactPersonName"
            placeholder="Your Name"
            className="w-full mt-1 border rounded-md px-3 py-2 text-sm focus:ring-2 focus:ring-[#93C047] focus:outline-none"
            onChange={(e) => handleInputChange(e.target.name, e.target.value)}
            value={userForm.contactPersonName}
          />
          <FormValidation
            value={userForm.contactPersonName}
            showError={!userForm.validContactPersonName}
          />
        </div>

        <div>
          <label className="block text-sm font-semibold">
            Email Address<span className="text-red-500">*</span>
          </label>
          <input
            type="email"
            name="emailAddress"
            placeholder="company@email.com"
            className="w-full mt-1 border rounded-md px-3 py-2 text-sm focus:ring-2 focus:ring-[#93C047] focus:outline-none"
            onChange={(e) => handleInputChange(e.target.name, e.target.value)}
            value={userForm.emailAddress}
          />
          <FormValidation
            value={userForm.emailAddress}
            showError={
              !userForm.validEmailAddress || !userForm.validEmailFormat
            }
            errorMsg={
              userForm.validEmailFormat ? "Must be valid email format." : ""
            }
          />
        </div>

        <div className="flex flex-col justify-end gap-3 pt-2 sm:flex-row">
          <div
            className="px-4 py-2 rounded-md bg-[#F58220] text-white hover:bg-[#D67E32] transition text-sm font-medium cursor-pointer text-center"
            onClick={() =>
              handleOpenUploadForm({
                firstForm: false,
                secondForm: false,
                downloadForm: true,
                paymentEvidenceForm: false,
              })
            }
          >
            Submit
          </div>
        </div>
      </div>
    </div>
  );
};

export default DownloadRFIForm;
